export default __webpack_public_path__ + "static/media/autotone_before.2c386200.png";